import { Button } from "@mantine/core";
import { IconCircleCheckFilled } from "@tabler/icons-react";
import "./ConfirmSuccessContent.scss";

interface ConfirmSuccessModalProps {
  onClose: () => void;
}

const ConfirmSuccessContent = ({ onClose }: ConfirmSuccessModalProps) => {
  const personalInfo = localStorage.getItem("personalInfo");
  const personalInfoObj = JSON.parse(personalInfo ?? "{}");
  const email = personalInfoObj.assignee.email;

  return (
    <div className="confirm-success-content-container">
      <div className="confirm-success-content">
        <IconCircleCheckFilled color="#67B574" size={64} />
        <h2>Your message has been sent successfully!</h2>
        <p>
          Your message has been sent to your tax pro{" "}
          {email ? <b>{email}</b> : ""}.<br /> Your tax professional will review
          it and get back to you soon.
        </p>
      </div>
      <span className="close-button-container">
        <Button
          className="close-button"
          color="#0077CC"
          variant="outline"
          size="md"
          onClick={onClose}
        >
          Close
        </Button>
      </span>
    </div>
  );
};

export default ConfirmSuccessContent;
